import { io } from "socket.io-client";
import { baseURL } from "../config/index";

const socket = io(baseURL, {
    autoConnect: false,
    transports: ['websocket']
});

export const connectSocket = () => {
    if (!socket.connected) {
        const token = localStorage.getItem("token");
        if (token) {
            socket.auth = { token };
            socket.connect();
            console.log("Socket connecting with token...");
        } else {
            console.error("Cannot connect socket: No token found in localStorage");
        }
    }
};

export const disconnectSocket = () => {
    if (socket.connected) {
        socket.disconnect();
    }
};

export const joinTrackingRoom = (visitID) => {
    console.log("Emitting join_visit_tracking for:", visitID);
    socket.emit("join_visit_tracking", visitID);
};

export const leaveTrackingRoom = (visitID) => {
    socket.emit("leave_visit_tracking", visitID);
};

export const onLocationUpdate = (callback) => {
    // Listen for the broadcasted event from server
    socket.on("location_update", callback);
};

export const offLocationUpdate = () => {
    socket.off("location_update");
};

export const onStatusUpdate = (callback) => {
    socket.on("status_update", callback);
};

export const offStatusUpdate = () => {
    socket.off("status_update");
};

export default socket;
